"use client";
import * as React from "react";
import { alpha, styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Link from "@mui/material/Link";
import NextLink from "next/link";

import ModeSwitch from "./ModeSwitch";
import { Typography } from "@mui/material";

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
  // borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  // backdropFilter: "blur(24px)",
  // border: "1px solid",
  // borderColor: (theme.vars || theme).palette.divider,
  // backgroundColor: theme.vars
  //   ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
  //   : alpha(theme.palette.background.default, 0.4),
  // boxShadow: (theme.vars || theme).shadows[1],
  // padding: "8px 12px",
}));

// Define the navigation items
let navItems = [
  { text: "Features", href: "/features" },
  { text: "Testimonials", href: "/testimonials" },
  { text: "Highlights", href: "/highlights" },
  { text: "Pricing", href: "/pricing" },
  { text: "FAQ", href: "/faq" },
  { text: "Blog", href: "/blog" },
];
navItems = [{ text: "sobecblobec", href: "/" }];
export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="static" // Changed from "fixed" to "static"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: "transparent",
        backgroundImage: "none",
        mt: 2, // Added a simple margin top for spacing from the top of the page
        mb: 2,
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box
            sx={{ flexGrow: 1, display: "flex", alignItems: "center", px: 0 }}
          >
            {" "}
            <Box sx={{ display: { xs: "flex", md: "flex" } }}>
              {navItems.map((item) => (
                <Link
                  key={item.text}
                  component={NextLink}
                  href={item.href}
                  variant="body1"
                  underline="none"
                  // color="info"
                  // size="small"
                  sx={{
                    fontWeight: "600",
                    mb: 0,
                    fontSize: 20,
                    "&::before": {
                      opacity: 0,
                    },
                  }}
                >
                  {item.text}
                </Link>
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 1,
              alignItems: "center",
            }}
          >
            <ModeSwitch />
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" }, gap: 1 }}>
            {" "}
            <ModeSwitch />
            {/* <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="top" open={open} onClose={toggleDrawer(false)}>
              <Box sx={{ p: 2, backgroundColor: "background.default" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                {navItems.map((item) => (
                  <MenuItem key={item.text} component={Link} href={item.href}>
                    {item.text}
                  </MenuItem>
                ))}
                <Divider sx={{ my: 3 }} />
                <MenuItem>
                  <Button
                    component={Link}
                    href="/signup"
                    color="primary"
                    variant="contained"
                    fullWidth
                  >
                    Sign up
                  </Button>
                </MenuItem>
                <MenuItem>
                  <Button
                    component={Link}
                    href="/signin"
                    color="primary"
                    variant="outlined"
                    fullWidth
                  >
                    Sign in
                  </Button>
                </MenuItem>
              </Box>
            </Drawer> */}
          </Box>
        </StyledToolbar>
        <Divider sx={{ m: 0 }}></Divider>
      </Container>
    </AppBar>
  );
}
